<template>
  <i :class="classes(n(), [$props.activated, n('--activated')], [$props.small, n('--small')])"><slot /></i>
</template>

<script lang="ts">
import { defineComponent } from 'virtual-vue';
import { stepItemIconProps } from '../props';
import { stepItemEmits } from '../item-emits';
import { createNamespace } from '../../utils/components';

const { name, n, classes } = createNamespace('step-item-icon');

export default defineComponent({
  name,
  props: stepItemIconProps,
  emits: stepItemEmits,
  setup() {
    return {
      n,
      classes,
    };
  },
});
</script>
